import protoRoot from "../proto-root";
import CameraAlarmStatus from "../private/CameraAlarmStatus";

const name = "setCameraAlarmRPCResponse";

function create({ result, status }: { result: "SUCCESS" | "FAILURE"; status: CameraAlarmStatus }) {
  const SetCameraAlarmRPCResponse = protoRoot.lookupType("comm.SetCameraAlarmRPCResponse");
  const ResultEnum = protoRoot.lookupEnum("Result");

  const payload = SetCameraAlarmRPCResponse.create({
    result: ResultEnum.values[result],
    status: CameraAlarmStatus.create(status)
  });

  return { payload, name };
}

const setCameraAlarmRpcResponse = { create, name };

export default setCameraAlarmRpcResponse;
